import { useState } from "react";
import ActionIcon from "../../../components/custom/ActionIcon";
import VirtualTable from "../../../components/custom/VirtualTable";
import { OBlobFile } from "../Shifts/types";
import { FlexContainer } from "./DetailsModal";
import CustomLightBox, { RenderLightBoxImage } from "../../../components/LightBox";
import UploadModal from "./UploadModal";
import { checkImageFile } from "../../../components/hr/RenderFile";
import PDFViewerModal from "../../../components/PDFViewer/PDFViewerModal";
import apiClient from "../../../apiClient";
import { notify } from "../../../utils";

export default function Files({
    files,
    uploadFile,
    deleteFile
}: {
    files: Array<OBlobFile>;
    uploadFile: (file) => Promise<void>;
    deleteFile: (file) => Promise<void>;
}) {

    const [viewFile, setViewFile] = useState(false);
    const [fileIndex, setFileIndex] = useState<number>();
    const [uploadModal, setUploadModal] = useState(false);
    const [viewPdfModal, setViewPdfModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState<OBlobFile>();
    const useSelectedFile = selectedFile || {
        s_file_name: '',
        s_file_link: ''
    };
    const images: Array<RenderLightBoxImage> = (files || []).map((item, i) => ({
        'url': item.s_file_link,
        'createdAt': item.t_created,
        'createdBy': item.s_created_by,
        'title': item.s_file_name,
        'comments': ''
    }));

    const handleViewImage = (file: OBlobFile) => {
        const { s_file_name } = file;
        const isImage = checkImageFile(s_file_name);

        if (!isImage) {
            if (s_file_name.includes('pdf')) {
                setViewPdfModal(true);
                setSelectedFile(file);
            } else {
                notify('Please download to view this file');
            }
            return;
        }

        for (let i = 0; i < files.length; i++) {
            if (file.s_file_name === files[i].s_file_name) {
                setFileIndex(i);
                break;
            }
        }
        setViewFile(true);
    }

    const downloadFile = (file: OBlobFile) => {
        fetch(file.s_file_link)
            .then((response) => response.blob())
            .then((blob) => {
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = file.s_file_name || 'download';
                document.body.appendChild(link); // Required for Firefox
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => console.error('Error fetching file:', error));
    }

    return (
        <div>
            <FlexContainer>
                <b>Files</b>
                <ActionIcon
                    type={'add'}
                    onClick={() => setUploadModal(true)}
                />
            </FlexContainer>
            <div>
                <VirtualTable<OBlobFile>
                    data={files}
                    mapping={[{
                        name: 'Date',
                        value: 't_created',
                        datetime: true,
                        utc: true
                    }, {
                        name: 'Name',
                        value: 's_file_name'
                    }, {
                        name: 'Uploaded by',
                        value: 's_created_by',
                        email: true
                    }, {
                        name: '',
                        value: 'fas fa-down',
                        icon: true,
                        function: item => downloadFile(item)
                    }, {
                        name: '',
                        value: 'fas fa-trash text-danger',
                        icon: true,
                        function: item => deleteFile(item)
                    }]}
                    numRows={10}
                    handleClick={item => handleViewImage(item)}
                />
            </div>
            <CustomLightBox
                images={images}
                lightBoxOpen={viewFile}
                setLightBoxOpen={setViewFile}
                index={fileIndex}
            />
            <UploadModal
                modal={uploadModal}
                setModal={setUploadModal}
                uploadFile={uploadFile}
            />
            <PDFViewerModal
                title={`${useSelectedFile.s_file_name}`}
                modal={viewPdfModal}
                setModal={setViewPdfModal}
                link={useSelectedFile.s_file_link}
            />
        </div>
    );
}